"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessPermissionsResponseAllOfToJSON = exports.GetBusinessPermissionsResponseAllOfFromJSONTyped = exports.GetBusinessPermissionsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetBusinessPermissionsResponseAllOfFromJSON(json) {
    return GetBusinessPermissionsResponseAllOfFromJSONTyped(json, false);
}
exports.GetBusinessPermissionsResponseAllOfFromJSON = GetBusinessPermissionsResponseAllOfFromJSON;
function GetBusinessPermissionsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currentUsers': (json['currentUsers'].map(_1.BusinessUserFullFromJSON)),
        'authUser': (json['authUser'].map(_1.BusinessPermissionFromJSON)),
    };
}
exports.GetBusinessPermissionsResponseAllOfFromJSONTyped = GetBusinessPermissionsResponseAllOfFromJSONTyped;
function GetBusinessPermissionsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currentUsers': (value.currentUsers.map(_1.BusinessUserFullToJSON)),
        'authUser': (value.authUser.map(_1.BusinessPermissionToJSON)),
    };
}
exports.GetBusinessPermissionsResponseAllOfToJSON = GetBusinessPermissionsResponseAllOfToJSON;
